"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.DeliveryFastColor = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _SvgIcon = require("../SvgIcon");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var DeliveryFastColor = function DeliveryFastColor(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, (0, _extends2.default)({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#DeliveryFastColor_svg__DeliveryFastColor_svg__clip0_19281_92437)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 32C0 14.327 14.327 0 32 0c17.673 0 32 14.327 32 32 0 17.673-14.327 32-32 32C14.327 64 0 49.673 0 32z",
    fill: "#F4F9E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.825 19.898c.08.552.427 1.894 1.184 2.841 3.079-.315 8.856-1.515 7.341-3.788-1.894-2.842-12.55-9.946-13.498-8.525-.947 1.42-.236 4.736 2.369 5.92-.569 1.894 1.5 3.157 2.604 3.552z",
    fill: "#fff",
    stroke: "#547012",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.571 19.45l-11.689 6.654a3 3 0 00-1.446 1.966l-2.66 12.156a3 3 0 00.913 2.86l10.142 9.22a3 3 0 003.485.397l12.555-7.039a3 3 0 001.468-1.998l2.51-11.919a3 3 0 00-.901-2.823l-9.685-8.937a4 4 0 00-4.692-.537z",
    fill: "#D4E3AC",
    stroke: "#547012",
    strokeWidth: 0.355
  }), /*#__PURE__*/React.createElement("mask", {
    id: "DeliveryFastColor_svg__a",
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 17,
    width: 33,
    height: 37
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.113 18.003l-14.231 8.1a3 3 0 00-1.447 1.967l-2.659 12.156a3 3 0 00.913 2.86l10.141 9.22a3 3 0 003.485.397l12.555-7.039a3 3 0 001.47-1.998l2.509-11.919a3 3 0 00-.901-2.823l-11.835-10.92z",
    fill: "#D4E3AC",
    stroke: "#000",
    strokeWidth: 0.355
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#DeliveryFastColor_svg__a)",
    stroke: "#547012"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.028 27.476L36.124 39.24l-3.951 13.61-12.218-11.106 3.073-14.268z",
    fill: "#81A11A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.326 53.447l4.098-14.115 14.326-8.318-3.188 13.661-15.236 8.772z",
    fill: "#97BA1E"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M35.57 19.45l-11.688 6.654a3 3 0 00-1.447 1.966l-2.659 12.156a3 3 0 00.913 2.86l10.141 9.22a3 3 0 003.485.397l12.555-7.039a3 3 0 001.47-1.998l2.509-11.919a3 3 0 00-.901-2.823l-9.686-8.937a4 4 0 00-4.691-.537z",
    stroke: "#547012",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.905 32.685c1.516 1.705 3.316 6.236 4.026 8.288-10.656-1.184-13.734-4.973-13.024-7.34-2.368-.475-4.026-2.369-3.552-4.5-3.552-1.658-3.315-5.21-2.605-5.21s13.26 6.63 15.155 8.762z",
    fill: "#fff",
    stroke: "#547012",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "DeliveryFastColor_svg__DeliveryFastColor_svg__clip0_19281_92437"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h64v64H0z"
  }))));
};

exports.DeliveryFastColor = DeliveryFastColor;
var _default = DeliveryFastColor;
exports.default = _default;